import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {
  quillEditor
} from "vue-quill-editor";
import Crumb from "@/components/Crumb";
import {
  ScheduleAll
} from "../../../API/api";
import Loading from "../../../components/popup/Loading";
import imgTitle from "../../../components/newSchedule/imgTitle.vue";
import {
  bytesToSize,
  formatTypeImg
} from "../../../util/util";
import CommonMemberIi from "../../../components/CommonMemberii";
import {
  Message
} from "element-ui";
import {
  isThisTypeNode
} from "typescript";
import VueUeditorWrap from "vue-ueditor-wrap";
import {
  dateToYMD,
  dateToHMS,
  ajax
} from '../../../util/util';
import debounce from '../../../util/debounce'
const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{
    header: 1
  }, {
    header: 2
  }], // custom button values
  [{
    list: "ordered"
  }, {
    list: "bullet"
  }],
  [{
    script: "sub"
  }, {
    script: "super"
  }], // superscript/subscript
  [{
    indent: "-1"
  }, {
    indent: "+1"
  }], // outdent/indent
  [{
    direction: "rtl"
  }], // text direction

  [{
    size: ["small", false, "large", "huge"]
  }], // custom dropdown
  [{
    header: [1, 2, 3, 4, 5, 6, false]
  }],

  [{
    color: []
  }, {
    background: []
  }], // dropdown with defaults from theme
  [{
    font: []
  }],
  [{
    align: []
  }],
  ["link", "image", "video"],
  ["clean"] // remove formatting button
];
export default {
  components: {
    quillEditor,
    Crumb,
    Loading,
    imgTitle,
    CommonMemberIi,
    VueUeditorWrap
  },
  data() {
    return {
      sendMeeting:true,
      hexiao_title:false,
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 400,
        // 初始容器宽度
        initialFrameWidth: "100%",
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        // api/ueditor/index?action=uploadfile&encode=utf-8
        //http://35.201.165.105:8000/controller.php
        serverUrl: "/api/ueditor/index?action=config&encode=utf-8",
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: process.env.VUE_APP_TITLE == "development" ? "/UE/" : "/static/UE/" ,
        //  UEDITOR_HOME_URL:
        //   process.env.NODE_ENV == "production" ? "/material/trade/ue/" : "/public/UE/",
      },
      meeting: {},
      one: require('../../../assets/images/schedule/1.png'),
      oneing: require('../../../assets/images/schedule/1_pr.png'),
      two: require('../../../assets/images/schedule/two.png'),
      three: require('../../../assets/images/schedule/three.png'),
      four: require('../../../assets/images/schedule/four.png'),
      twoing: require('../../../assets/images/schedule/2_pr.png'),
      threeing: require('../../../assets/images/schedule/3_pr.png'),
      fouring: require('../../../assets/images/schedule/4_pr.png'),
      changeIt: require('../../../assets/images/schedule/changeIcon.png'),
      crumb: [],
      isLoading: false,
      // imageArr:[one,two,three,four],
      introList: [{
          label: "会议方式",
          prop: "roomType",
        },
        {
          label: "重复类型",
          prop: "repeatType",
        },
        {
          label: "会议时间",
          prop: 'startTime'
        },
        {
          label: "会议地点",
          prop: "roomName",
        },
        {
          label: "邀请人员",
          prop: "userItems",
          children: {
            prop: "headPic"
          }
        },
      ],
      staring: [],
      showAll: [{
          label: "会议类型 ",
          prop: "type",
        },
        {
          label: "所属项目",
          prop: "projectName",
        },
        {
          label: "发起人",
          prop: "createUser",
          children: {
            prop: "headPic"
          }
        },
        {
          label: "会议议程",
          prop: "agenda",
        },
        {
          label: "记录人员",
          prop: "recorderUserItems",
          children: {
            prop: "headPic"
          }
        },
        {
          label: '会议纪要',
          prop: "memo",
        }
      ],
      editorValue: "",
      editorOption: {

      },
      fileName: "",
      fileameView:[],
      filePath: "",
      filePathView:[],
      fileuploadName:[],
      filePathList:[],
      typeImg: '',
      typeImgList:[],
      fileSize: '',
      showPic: false,
      isUndo: false,
      waitUndoId: null,
      waitUndoTit: null,
      isLoading: false,
      isModal: false,
      memoId: null,
      memoReceivers: [],
      outMember: "",
      isEdit: false,
      saveLoading: false,
      joinId: [],
      imageArry: [],
      auditorReason: "", //拒绝理由,
      showAuditModal: false,
      showJoinPeople: false,
      num: 1,
      startCountdown: 0,
      endCountdown: 0,
      timerStart: null,
      timeEnd: null,
      getTimer:null,
      cancelVacaDialog:false,
      formInline: {
        uids: [],
        reason: ''
      },
      ruleInline: {
        uids: [{
          required: true,
          message: '请选择未外出人员',
          trigger: 'blur',
          type: 'array'
        }],
        reason: [{
            required: true,
            message: '请输入取消本次外出的原因',
            trigger: 'blur'
          },
          {
            type: 'string',
            max: 120,
            message: '销假原因最多120个字',
            trigger: 'blur'
          }
        ]
      },
      userInfoId:JSON.parse(localStorage.getItem("userInfo")).id,
      undowaichuInfo:{},
      allUserWaichuStatus:[],
      showOtherPeople:false,//显示别人撤销外出理由
      otherPeopleName:[],//其他人撤销外出的名字
      showAllPeopleReason:false,
      single:''
    }
  },
  computed: {

  },
  beforeDestroy() {
    if (this.timerStart) { //如果定时器还在运行 或者直接关闭，不用判断
      clearInterval(this.timerStart); //关闭
    }
    if (this.timeEnd) { //如果定时器还在运行 或者直接关闭，不用判断
      clearInterval(this.timeEnd); //关闭
    }
  },
  mounted() {
    this.getDetail()
    // this.getNotice()
  },
  methods: {
    checkItCancel(obj){
      obj.person_undo_waichu=obj.person_undo_waichu==1?2:1;
      //1已经取消外出2没有取消外出
  if(obj.person_undo_waichu==1){
    this.formInline.uids.push(obj.uid)  
  }
  if(obj.person_undo_waichu==2){
    this.formInline.uids.splice(this.formInline.uids.indexOf(obj.uid), 1)
  }
  
    },
    handleSubmitCancelVaca(name) {
      console.log(this.single,'single')
      if(this.single==true){
        this.formInline.uids=this.meeting.allUserWaichuStatus.map(i=>i.uid)
      }
      console.log(this.formInline.uids,'this.formInline.uids')
      this.$refs[name].validate((valid) => {
       
        this.formInline.meet_id = this.meeting.id
        if (valid) {
          this.$http.post(ScheduleAll.undowaichu, this.qs.stringify(this.formInline), {
            headers: {
              'Authorization': 'Bearer ' + this.$cookie.get('token')
            }
          }).then((res) => {
            let _data=res.data
            if (_data.retCode !== 0) {
              this.isToast = true
              this.toastMsg = _data.retMsg
            } else {
              this.isToast = true;
              this.toastMsg = '提交成功';
              this.toastState = 'success';
              this.formInline={
                uids:'',
                reason:'',
              }
              this.single=false;
              this.cancelVacaDialog=false;

            }
            setTimeout(() => {
              this.isToast = false
              this.toastState = null
              this.toastMsg = null
              this.modalValue = ''
              this.$emit('on-cancel')
              this.getDetail()
            }, 1500)

          })
          // this.$Message.success('Success!');
        } else {
          // this.$Message.error('Fail!');
        }
      })
    },
    //点击撤销外出的按钮
    cancelMeetingOut(){
      console.log(this.formInline);
      this.formInline.reason = '',      
      this.cancelVacaDialog=true;
    },
    toMemo() {
      this.isEdit = !this.isEdit;

      // this.editId = item.id;
    },
    cancelMeeting() {

      debounce(() => {
        this.$http
        .post(ScheduleAll.cancel, this.qs.stringify({
          id: this.waitUndoId
        }), {
          headers: {
            Authorization: "Bearer " + this.$cookie.get("token")
          }
        })
        .then(res => {
          this.isLoading = false;
          if (res.data.retCode == 0) {
            this.isToast = true;
            this.$message({
              message: '取消会议成功',
              type: 'success'
            });
            this.toastState = "success";
            setTimeout(() => {
              this.$router.push('/new/schedule/list')
            }, 1500);
          } else {
            if (_data.retCode == 100014) {} else {
              this.$message.error(`${res.data.retMsg}`);
            }
          }

        })
        .catch(err => {
          this.isToast = true;
          this.toastState = null;
          // this.toastMsg = err.toString();
          this.$message.error(`${err.toString()}`);
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        })
        .finally(() => {});
      }, 1000)
    },
    cancelModal(id, name) {
      this.isUndo = true;
      this.waitUndoId = id;
      this.waitUndoTit = name;
    },
    toCopy(id, type) {
      this.isLoading = true;
      this.$router.push({
        path: "/new/schedule/add",
        query: {
          id: id,
        }
      });
    },
    toEdit(id, type) {
      this.isLoading = true;
      this.$router.push({
        path: "/new/schedule/add",
        query: {
          id: id,
          type: 'edit',
        }
      });
    },
    /* kb转mb */
    toSize(size) {
      return size ? bytesToSize(size) : "";
    },
    compare(prop) {
      return function (obj1,obj2) {
      let val1 = obj1[prop];
      let val2 = obj2[prop];
      return val1 -val2;
    }
      },
    //签到
    checkItJoin(obj, item) {
      //isMsgMemo：会议纪要发送状态，0未发送、1已发送。
      // Number(this.meeting.isMsgMemo) !== 2 && item.label == '参加人员'
      if(obj.showReason == "已撤销") {
        console.log(2)
      } else {
        let canClickIt
        if (item.label == '参加人员' || item.label == '实际同行') {
          canClickIt = true;
        } else {
          canClickIt = false;
        }
        // console.log(obj,'obj');
        if (this.meeting.isMsgMemo != 2 && canClickIt) {
          //1代表已签到 2代表未签到
          obj.isAttend = Number(obj.isAttend) === 2 ? 1 : 2;
          if (obj.isAttend === 2) {
            if (obj.reason == '已到') {
              obj.showReason = "签到"
              obj.reason = "未到"
  
            } else {
              obj.showReason = obj.reason
            }
            this.joinId.splice(this.joinId.indexOf(obj.id), 1)
            this.meeting.showAllNotAttendList.push(obj)
            // console.log(this.meeting.showAllNotAttendList,'this.meeting.showAllNotAttendList')
            // this.meeting.showAllNotAttendList.sort(this.compare("id"));
          } else if (obj.isAttend === 1) {
            this.joinId.push(obj.id)
            obj.showReason = '已到'
            for(let i=0;i < this.meeting.showAllNotAttendList.length;i++){
              if(this.meeting.showAllNotAttendList[i].id===obj.id){
                this.meeting.showAllNotAttendList.splice(i, 1)
              }
            }
          }
          this.$http
            .post(
              ScheduleAll.attend,
              this.qs.stringify({
                id: this.$route.query.id,
                attendList: this.joinId
              }), {
                headers: {
                  Authorization: "Bearer " + this.$cookie.get("token")
                }
              }
            ).then((res) => {
              // if(){}
            })
        } else {
  
        }
      }
     

    },
    //  头部照片
    getTopImg() {
      if (this.meeting.roomType === '内部会议') {
        if (this.meeting.timeStatusString == '已结束') {
          if (Number(this.meeting.isMsgMemo) === 2) {
            //  ：所有高亮
            this.imageArry = [{
                img: this.one,
                status: '未开始'
              },
              {
                img: this.two,
                status: '进行中'
              },
              {
                img: this.three,
                status: '已结束'
              },
              {
                img: this.fouring,
                status: '会议纪要已发送',
                class: 'change',
              },
            ]
          } else {
            // ：未开始高亮、进行中高亮、已结束高亮。
            this.imageArry = [{
                img: this.one,
                status: '未开始'
              },
              {
                img: this.two,
                status: '进行中'
              },
              {
                img: this.threeing,
                status: '已结束',
                class: 'change',
              },
              {
                img: this.four,
                status: '会议纪要已发送'
              },
            ]
          }
        } else if (this.meeting.timeStatusString == '进行中') {
          //：未开始高亮、进行中高亮
          this.imageArry = [{
              img: this.one,
              status: '未开始'
            },
            {
              img: this.twoing,
              status: '进行中',
              class: 'change',
            },
            {
              img: this.three,
              status: '已结束'
            },
            {
              img: this.four,
              status: '会议纪要已发送'
            },
          ]
        } else {
          //：未开始高亮
          this.imageArry = [{
              img: this.oneing,
              status: '未开始',
              class: 'change',
            },
            {
              img: this.two,
              status: '进行中'
            },
            {
              img: this.three,
              status: '已结束'
            },
            {
              img: this.four,
              status: '会议纪要已发送'
            },
          ]
        }
      } else {
        //外出开会状态 文字 this.meeting.auditorStatusName用它做处理了
        if (this.meeting.timeStatusString == '已结束') {
          if (Number(this.meeting.isMsgMemo) === 2) {

            //所有高亮
            this.imageArry = [{
                img: this.one,
                status: '未开始'
              },
              {
                img: this.two,
                status: '进行中'
              },
              {
                img: this.three,
                status: '已结束'
              },
              {
                img: this.fouring,
                status: `${this.meeting.auditorStatusName}/会议纪要已发送`,
                class: 'change',
              },
            ]
          } else {
            //：未开始高亮、待审核/进行中高亮、已结束高亮。
            this.imageArry = [{
                img: this.one,
                status: '未开始'
              },
              {
                img: this.two,
                status: '进行中'
              },
              {
                img: this.threeing,
                status: `${this.meeting.auditorStatusName}/已结束`,
                class: 'change',
              },
              {
                img: this.four,
                status: '会议纪要已发送'
              },
            ]
          }
        } else if (this.meeting.timeStatusString == '进行中') {
          //：未开始高亮、进行中高亮
          this.imageArry = [{
              img: this.one,
              status: '未开始'
            },
            {
              img: this.twoing,
              status: `${this.meeting.auditorStatusName}/进行中`,
              class: 'change',
            },
            {
              img: this.three,
              status: '已结束'
            },
            {
              img: this.four,
              status: '会议纪要已发送'
            },
          ]
        } else {
          //：未开始高亮
          this.imageArry = [{
              img: this.oneing,
              status: `${this.meeting.auditorStatusName}/未开始`,
              class: 'change',
            },
            {
              img: this.two,
              status: '进行中'
            },
            {
              img: this.three,
              status: '已结束'
            },
            {
              img: this.four,
              status: '会议纪要已发送'
            },
          ]
        }
      }
    },
    auditIt(val) {
      this.showAuditModal = false;
      if (val === 3) {
        if (!this.auditorReason) {
          Message.warning({
            message: "请输入具体原因",
            type: "warning",
          });
          return;
        }
      }
      let params = {
        id: this.$route.query.id,
        auditorStatus: val,
        auditorReason: this.auditorReason,
      }
      this.$http
        .post(
          ScheduleAll.review,
          this.qs.stringify({
            id: this.$route.query.id,
            auditorStatus: val,
            auditorReason: this.auditorReason
          }), {
            headers: {
              Authorization: "Bearer " + this.$cookie.get("token")
            }
          }
        )
        .then(res => {
          if (res.data.retCode === 0) {
            Message.success({
              message: "提交成功",
              type: "success",
            });
            this.closeAuditModal();
            this.$router.push("/new/schedule/list");
          } else {
            Message.error({
              message: res.data.retMsg,
              type: "error",
            });
          }
        })
    },
    closeAuditModal() {
      this.showAuditModal = false;
      this.auditorReason = "";
    },
    // getNotice() {
    //   let vm = this;
    //   this.getDetail();
    //   setInterval(function () {
    //     vm.num=vm.num+1;
    //     vm.getDetail();
    //   }, 5000);
    // },
    //当前时间与会议开始时间的相差的秒数
    getScond(start, end) {
      let startTime = new Date(start).getTime();
      let endTime = new Date(end).getTime();
      let oDate1 = dateToYMD(new Date()) + ' ' + dateToHMS(new Date());
      let nowTime = new Date(oDate1).getTime()
      let startPoor = (startTime - nowTime) / 1000
      let endPoor = (endTime - nowTime) / 1000
      //getTime() 方法可返回距 1970 年 1 月 1 日之间的毫秒数
      //如果还没开始 就倒计时 更改头部图片
      if (startPoor > 0) {
        this.startCountdown = startPoor;
        //还没开始
        this.timerStart = setInterval(() => {
          this.startCountdown--;
          if (this.startCountdown == 0) {
            clearInterval(this.timerStart);
            //已经开始处理数据
            // this.meeting.timeStatusString = '进行中';
            // this.getDetailTwo()
            // this.getTopImg()
            let vm = this;
            this.getTimer = setInterval(function () {
              vm.getDetailTwo();
            }, 6000);

          }
        }, 1000)

      } else if (startPoor = 0) {
        this.meeting.timeStatusString = '进行中';
      }

      if (endPoor > 0) {
        //还没结束
        this.endCountdown = endPoor;

        this.timeEnd = setInterval(() => {
          this.endCountdown--;
          if (this.endCountdown == 0) {
            clearInterval(this.timeEnd);
            //已经结束处理数据
            this.meeting.timeStatusString = '已结束';
            this.getTopImg()
          }
        }, 1000)
      }

    },
    getStaring(allUser) {
      // if (this.meeting.timeStatusString != '已结束') {
      //   this.meeting.notAttendList = this.meeting.notAttendList.filter(item => item.reason == '请假' || item.reason == '外出' || item.reason == '拒绝')
      // }
      if (this.meeting.allowNotAttendList == true) {
        this.staring = [{
            label: `${allUser}`,
            prop: "needAttendList",
            children: {
              prop: "headPic"
            }
          },
          {
            label: "缺席人员",
            prop: "showAllNotAttendList",
            children: {
              prop: "headPic"
            }
          },
        ];
      } else {
        this.staring = [{
          label: `${allUser}`,
          prop: "needAttendList",
          children: {
            prop: "headPic"
          }
        }, ];
      }
    },
    getDetailTwo() {
      const _self = this;

      this.$http
        .post(
          ScheduleAll.detail,
          this.qs.stringify({
            id: this.$route.query.id
          }), {
            headers: {
              Authorization: "Bearer " + this.$cookie.get("token")
            }
          }
        )
        .then(res => {
          const _data = JSON.parse(JSON.stringify(res.data));
          // if (this.num === 1) {
          this.crumb = [{
              label: "日程计划",
              pathName: "schedulePlan",
            },
            {
              label: "日程列表",
              pathName: "scheduleList",
            },
            {
              label: _data.retData.name,
              path: ''
            }
          ]
          // }
          if (_data.retCode === 0) {
            // 处理数据
            this.getScond(_data.retData.startTime, _data.retData.endTime)
            _data.retData.projectName = _data.retData.projectName == '' ? '无项目' : _data.retData.projectName
            for (let key in _data.retData) {
              if (key == 'roomType') {
                if (_data.retData[key] == 1) {
                  _data.retData[key] = '内部会议'
                } else if (_data.retData['roomType'] == 2) {
                  if (_data.retData['waichuType'] == 1) {
                    _data.retData[key] = '本市外出开会'
                  } else {
                    _data.retData[key] = '异地出差'
                  }
                }
              }
              if (key == 'roomName') {
                //会议地点
                if (_data.retData['roomType'] == '内部会议') {
                  _data.retData[key] = _data.retData[key] == '' ? '' : _data.retData['roomContent'] + '(' + _data.retData['roomName'] + ')'
                } else {
                  if (_data.retData['area']) {
                    let area = _data.retData['area'][0] === _data.retData['area'][1] ? _data.retData['area'].slice(1).join('') : _data.retData['area'].join('')
                    _data.retData[key] = area + _data.retData['roomDetail']
                  }

                }

              }
              if (key == 'startTime') {
                //会议时间
                if (_data.retData[key].slice(0, 10) === _data.retData['endTime'].slice(0, 10)) {
                  _data.retData[key] = _data.retData[key] + '-' + _data.retData['endTime'].slice(11, 16)
                } else {
                  _data.retData[key] = _data.retData[key] + '-' + _data.retData['endTime']

                }
              }
              if (key == 'createUser') {
                //创建人
                _data.retData[key] = [_data.retData[key]]

              }
              if (key == 'repeatType') {
                //会议类型
                _data.retData[key] = _data.retData['repeatType'] == 0 ? '单次会议' : '固定会议'

              }
              if (key == 'contactName' && _data.retData[key] != '' && _data.retData[key] != null) {
                _data.retData[key] = _data.retData['contactName'] + '/' + _data.retData['contactSummary']
              }
            }
            this.meeting = _data.retData;
            if(this.meeting.timeStatusString=='进行中'){
              clearInterval(this.getTimer);
            } 

            this.getTopImg();
            if (this.meeting.roomType == '本市外出开会' || this.meeting.roomType == '异地出差') {
              //左边标题改变
              this.introList = [{
                  label: "会议方式",
                  prop: "roomType",
                },
                {
                  label: "重复类型",
                  prop: "repeatType",
                },
                {
                  label: "外出时间",
                  prop: 'startTime'
                },
                {
                  label: "外出城市",
                  prop: "roomName",
                },
                {
                  label: "同行人员",
                  prop: "userItems",
                  children: {
                    prop: "headPic"
                  }
                },
              ];
              //如果会议纪要是空就代表 没有上传会议纪要，可以点击签到
              // if (this.meeting.isMsgMemo != 2) {
              //   this.staring = [{
              //     label: "实际同行",
              //     prop: "allUserItems",
              //     children: {
              //       prop: "headPic"
              //     }
              //   }, ];
              // } else {
              //   this.staring = [{
              //       label: "实际同行",
              //       prop: "allUserItems",
              //       children: {
              //         prop: "headPic"
              //       }
              //     },
              //     {
              //       label: "缺席人员",
              //       prop: "notAttendList",
              //       children: {
              //         prop: "headPic"
              //       }
              //     },
              //   ];
              // }
              this.getStaring('实际同行')
              if (this.meeting.contactName != null) {
                this.showAll = [{
                    label: "会议类型 ",
                    prop: "type",
                  },
                  {
                    label: "所属项目",
                    prop: "projectName",
                  },
                  {
                    label: '对接人员',
                    prop: 'contactName'
                  },
                  {
                    label: "发起人",
                    prop: "createUser",
                    children: {
                      prop: "headPic"
                    }
                  },
                  {
                    label: "会议议程",
                    prop: "agenda",
                  },
                  {
                    label: "记录人员",
                    prop: "recorderUserItems",
                    children: {
                      prop: "headPic"
                    }
                  },
                  {
                    label: '会议纪要',
                    prop: "memo",
                  }
                ];
              }

            } else {
              this.getStaring("参加人员")
            }
            this.joinId = this.meeting.yesAttendList.map(function (item) {
              return item.id;
            })
            this.isEdit = this.meeting.isEdit;
            // }
            if (this.num === 1) {
              this.memo = _data.retData.memo;
            }
            for (let i of this.meeting.needAttendList) {
              i.showReason = i.reason
            }
            this.meeting.showAllNotAttendList = [...this.meeting.outLeaveAttendList, ...this.meeting.notOutLeaveAttendList]
            let myId = JSON.parse(localStorage.userInfo).id
            //创建人和会议记录人员id
            let showAllId = [...this.meeting.recorder, this.meeting.creatorId];
            ///创建人和会议记录人员id里边有本人id就显示参与人员
            if (showAllId.indexOf(myId) > -1) {} else {
              //没有的话就只显示缺席人员
              this.staring = this.staring = [{
                label: "缺席人员",
                prop: "showAllNotAttendList",
                children: {
                  prop: "headPic"
                }
              }, ];
            }
            // setTimeout(() => {
            //   this.editorValue = _data.retData.memo || '';
            //   this.fileName = _data.retData.fileName || "";
            //   this.typeImg = formatTypeImg(
            //     this.fileName.substring(this.fileName.lastIndexOf("."), this.fileName.length)
            //   );
            //   this.filePath = _data.retData.filePath || "";
            // }, 0);
          } else {

          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    //获取详情
    getDetail() {
      this.fileuploadName = [],
      this.fileameView = [],
      this.filePathView = [];
      this.filePathList=[];
      this.editorValue = ''
      const _self = this;
      // this.isLoading = true;
      if (this.num === 1) {
        this.isLoading = true;
      } else {
        this.isLoading = false;

      }
      this.$http
        .post(
          ScheduleAll.detail,
          this.qs.stringify({
            id: this.$route.query.id
          }), {
            headers: {
              Authorization: "Bearer " + this.$cookie.get("token")
            }
          }
        )
        .then(res => {
          this.isLoading = false;
          const _data = JSON.parse(JSON.stringify(res.data));
          if(res.data.retData.auditorStatusName === '已撤销') {
            this.hexiao_title = true
          } else {
            this.hexiao_title = false
          }
          if(_data.retData.fileName) {
            this.fileameView=_data.retData.fileName
            this.filePathView = Object.assign([], _data.retData.fileName.map(t => {
              return formatTypeImg(
                t.substring(t.lastIndexOf("."), t.length) 
              )
            }));
            this.fileuploadName = _data.retData.filePath
          } else {
            console.log('没有')
          }

          console.log(this.fileameView.length,'1111111111')
          // if (this.num === 1) {
          this.crumb = [{
              label: "日程计划",
              pathName: "schedulePlan",
            },
            {
              label: "日程列表",
              pathName: "scheduleList",
            },
            {
              label: _data.retData.name,
              path: ''
            }
          ]
          // }
          if (_data.retCode === 0) {
            // 处理数据
            this.getScond(_data.retData.startTime, _data.retData.endTime)
            _data.retData.projectName = _data.retData.projectName == '' ? '无项目' : _data.retData.projectName
            for (let key in _data.retData) {
              if (key == 'roomType') {
                if (_data.retData[key] == 1) {
                  _data.retData[key] = '内部会议'
                } else if (_data.retData['roomType'] == 2) {
                  if (_data.retData['waichuType'] == 1) {
                    _data.retData[key] = '本市外出开会'
                  } else {
                    _data.retData[key] = '异地出差'
                  }
                }
              }
              if (key == 'roomName') {
                //会议地点
                if (_data.retData['roomType'] == '内部会议') {
                  _data.retData[key] = _data.retData[key] == '' ? '' : _data.retData['roomContent'] + '(' + _data.retData['roomName'] + ')'
                } else {
                  if (_data.retData['area']) {
                    let area = _data.retData['area'][0] === _data.retData['area'][1] ? _data.retData['area'].slice(1).join('') : _data.retData['area'].join('')
                    _data.retData[key] = area + _data.retData['roomDetail']
                  }

                }

              }
              if (key == 'startTime') {
                //会议时间
                if (_data.retData[key].slice(0, 10) === _data.retData['endTime'].slice(0, 10)) {
                  _data.retData[key] = _data.retData[key] + '-' + _data.retData['endTime'].slice(11, 16)
                } else {
                  _data.retData[key] = _data.retData[key] + '-' + _data.retData['endTime']

                }
              }
              if (key == 'createUser') {
                //创建人
                _data.retData[key] = [_data.retData[key]]

              }
              if (key == 'repeatType') {
                //会议类型
                _data.retData[key] = _data.retData['repeatType'] == 0 ? '单次会议' : '固定会议'

              }
              if (key == 'contactName' && _data.retData[key] != '' && _data.retData[key] != null) {
                _data.retData[key] = _data.retData['contactName'] + '/' + _data.retData['contactSummary']
              }
            }
            this.meeting = _data.retData;
            this.getTopImg();
            console.log(this.userInfoId,'userInfoId====')
          this.allUserWaichuStatus = JSON.parse(JSON.stringify(this.meeting.allUserWaichuStatus));
         //刚开始进来如果有人已经撤销外出就禁用
          for (let i of this.meeting.allUserWaichuStatus) {
            if (i.person_undo_waichu == 1) {
              i.disabled = true;
            } else {
              i.disabled = false;
            }
          }
          //找出自己的信息
          let meetingitem=JSON.parse(JSON.stringify(this.meeting.allUserWaichuStatus))
          for (let i of meetingitem) {
            if (i.uid == this.userInfoId) {
             
              this.undowaichuInfo = i
            }

          }
     console.log(this.allUserWaichuStatus,'hhhhhhh------')
          //如果自己没撤销外出并且没有全员撤销 别人撤销了 就显示别人撤销的理由
          this.showOtherPeople = this.meeting.allUserWaichuStatus.some(user => {
            return user.person_undo_waichu == 1 && user.uid != this.userInfoId&&this.meeting.undo_waichu!=1
          })
          let otherPeople = this.meeting.allUserWaichuStatus.filter(i => i.person_undo_waichu == 1);
         //其他人撤销的名字
          this.otherPeopleName = otherPeople.map(i => i.userName)
          this.otherPeopleName=this.otherPeopleName.join('、')
        
            if (this.meeting.roomType == '本市外出开会' || this.meeting.roomType == '异地出差') {
              //左边标题改变
              this.introList = [{
                  label: "会议方式",
                  prop: "roomType",
                },
                {
                  label: "重复类型",
                  prop: "repeatType",
                },
                {
                  label: "外出时间",
                  prop: 'startTime'
                },
                {
                  label: "外出城市",
                  prop: "roomName",
                },
                {
                  label: "同行人员",
                  prop: "userItems",
                  children: {
                    prop: "headPic"
                  }
                },
              ];
              this.getStaring('实际同行')
              if (this.meeting.contactName != null) {
                this.showAll = [{
                    label: "会议类型 ",
                    prop: "type",
                  },
                  {
                    label: "所属项目",
                    prop: "projectName",
                  },
                  {
                    label: '对接人员',
                    prop: 'contactName'
                  },
                  {
                    label: "发起人",
                    prop: "createUser",
                    children: {
                      prop: "headPic"
                    }
                  },
                  {
                    label: "会议议程",
                    prop: "agenda",
                  },
                  {
                    label: "记录人员",
                    prop: "recorderUserItems",
                    children: {
                      prop: "headPic"
                    }
                  },
                  !this.hexiao_title ? {
                    label: '会议纪要',
                    prop: "memo",
                  }:{}
                ];
              }

            } else {
              this.getStaring("参加人员")
            }
            this.joinId = this.meeting.yesAttendList.map(function (item) {
              return item.id;
            })
            this.isEdit = this.meeting.isEdit;
            // }
            if (this.num === 1) {
              this.memo = _data.retData.memo;
            }
            for (let i of this.meeting.needAttendList) {
              i.showReason = i.reason
            }
            this.meeting.showAllNotAttendList = [...this.meeting.outLeaveAttendList, ...this.meeting.notOutLeaveAttendList]
            let myId = JSON.parse(localStorage.userInfo).id
            //创建人和会议记录人员id
            let showAllId = [...this.meeting.recorder, this.meeting.creatorId];
            ///创建人和会议记录人员id里边有本人id就显示参与人员
            if (showAllId.indexOf(myId) > -1) {} else {
              //没有的话就只显示缺席人员
              this.staring = this.staring = [{
                label: "缺席人员",
                prop: "showAllNotAttendList",
                children: {
                  prop: "headPic"
                }
              }, ];
            }
            setTimeout(() => {
              this.editorValue = _data.retData.memo || '';
              this.fileName =  "";
              this.typeImg = formatTypeImg(
                this.fileName.substring(this.fileName.lastIndexOf("."), this.fileName.length)
              );
              this.filePath = _data.retData.filePath || "";
            }, 0);
          } else {

          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    download(filePath, fileName) {
      window.open(`/api/task/filedownload?fileName=${encodeURIComponent(fileName)}&filePath=${filePath}`)
    },
    /* 下载文件 */
    download(item) {
      console.log(this.fileameView[item])
      // this.storeDetail.fileContent.forEach((e) => {
      const aDom = document.createElement("a"); // 创建标签
      const evt = document.createEvent("HTMLEvents"); // 创建事件
      evt.initEvent("click", false, false); // 初始化事件，绑定点击事件，不冒泡，不阻止浏览器默认行为
      aDom.download = item.name || this.fileameView[item];
      aDom.href = encodeURI(item.img || this.filePathView[item]); // 对地址进行编码
      aDom.dispatchEvent(evt); // 触发事件
      aDom.click();
      // });
    },
    //发送会议纪要
    async sendMemo() {
      const userList = this.memoReceivers.map(item => {
        return item.id;
      });
      const contactInfo = this.outMember.split(";");
      await this.save();
      let params = {
        id: this.$route.query.id,
        userList,
        contactInfo: contactInfo,
        memo: this.editorValue,
        // fileName: this.fileName,
        // filePath: this.filePath.url,
      }
      await this.$http
        .post(
          ScheduleAll.sendMemo,
          this.qs.stringify(params), {
            headers: {
              Authorization: "Bearer " + this.$cookie.get("token")
            }
          }
        )
        .then(res => {
          this.isModal = false;
          const _data = res.data;
          this.isToast = true;
          if (_data.retCode === 0) {
            this.$message({
              message: '发送成功',
              type: 'success'
            });
            // this.getDetail()
          } else {
            // this.toastMsg = _data.retMsg;
            this.$message.error(`${_data.retMsg}`);
            this.toastState = null;
          }
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        })
        .catch(() => {

          this.isToast = true;
          // this.toastMsg = "网络错误";
          this.$message.error('网络错误');
          this.toastState = null;
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        });

    },
    //发送会议纪要弹窗
    sendMemoConfirm() {
      // if (this.joinId == '' && this.meeting.isMsgMemo == 2) {
      //   this.$message({
      //     message: '请先对参会人员进行签到后，在发送会议纪要',
      //     type: 'warning'
      //   });
      // } else 
      if (this.editorValue == '') {
        this.$message({
          message: '会议记录不能为空',
          type: 'warning'
        });
      } else {
        this.isModal = true;
        this.memoId = this.$route.query.id;
        this.memoReceivers = this.meeting.needAttendList.map(item => {
          return item;
        });
        this.outMember = this.meeting.contactInfo ?
          JSON.parse(this.meeting.contactInfo).join(";") :
          "";
      }
      // this.save();
    },
   async save() {
      if (this.editorValue == '') {
        this.$message({
          message: '会议记录不能为空',
          type: 'warning'
        });
      } else {
        // this.saveLoading = true;
        const memo = this.editorValue;
        // const filePath = this.filePath.url;
        let fileName = this.filePathList.map((item,idx) => {
          return item.name
        })
        let filePath  =  this.filePathList.map((item,idx) => {
          return item.response.url
        })
        this.fileameView.map(r => {
          return fileName.push(r)
        })
        this.fileuploadName.map(r => {
          return filePath.push(r)
        })

        console.log(filePath,fileName);
        await this.$http
          .post(
            ScheduleAll.updatememo,
            this.qs.stringify({
              id: this.$route.query.id,
              memo,
              filePath,
              fileName
            }), {
              headers: {
                Authorization: "Bearer " + this.$cookie.get("token")
              }
            }
          )
          .then(res => {
            const _data = res.data;
            this.isToast = true;
            if (_data.retCode === 0 && this.isModal == false) {
              // this.toastMsg = "保存成功";
              this.$message({
                message: '保存成功',
                type: 'success'
              });
              this.toastState = "success";
              filePath = [],
              fileName = []
            } else if (this.isModal == true) {} else {
              this.$message.error(`${_data.retMsg}`);
              // this.toastMsg = _data.retMsg;
              this.toastState = null;
            }
            setTimeout(() => {
              this.isToast = false;
              this.saveLoading = false;
              if (_data.retCode === 0) {
                // this.$router.back()
                this.isEdit = false;
                this.getDetail();
              }
            }, 1500);
          })
          .catch(() => {
            this.saveLoading = true;
            this.isToast = true;
            this.$message.error('网络错误');
            // this.toastMsg = "网络错误";
            this.toastState = null;
            setTimeout(() => {
              this.isToast = false;
            }, 1500);
          });
      }
    },
    beforeUpload() {
      if (this.filePathList.length+this.fileuploadName.length==5) {
        this.isToast = true;
        this.toastMsg = "最多可以上传5个附件";
        this.$message({
          message: '最多可以上传5个附件',
          type: 'warning'
        });
        setTimeout(() => {
          this.isToast = false;
          this.toastMsg = "";
        }, 1500);
        return false;
      } else {
        return true;
      }
    },
    handleEditSuccess(res) {
      // 获取富文本组件实例
      const editor = this.$refs.QuillEditors;
      const {
        quill
      } = editor;

      this.$nextTick(() => {
        // 如果上传成功
        if (res) {
          // 获取光标所在位置
          const length = quill.getSelection().index;
          // 插入图片，res为服务器返回的图片链接地址
          quill.insertEmbed(length, "image", res);
          // 调整光标到最后
          quill.setSelection(length + 1);
        } else {
          // 提示信息，需引入Message
          Message.error("图片插入失败");
        }
      });
    },
    handleSuccess(res, file, fileList) {
      this.filePath = file.response;
      this.fileName = file.name;
      this.isToast = true;
      // this.filePathList=[];
      fileList.map((item,idx) => {
        if(fileList.length == 1 ) {
          return this.filePathList.push(Object.assign({},item,{img:formatTypeImg(
            item.response.original.substring(item.response.original.lastIndexOf("."), item.response.original.length)
          )}))
        } else {
          let ele = fileList.pop();
          return this.filePathList.push(Object.assign({},ele,{img:formatTypeImg(
            ele.response.original.substring(ele.response.original.lastIndexOf("."), ele.response.original.length)
          )}))
        }
      })
      // this.toastMsg = "上传成功";
      console.log(this.filePathList,fileList,'upload')
      this.$message({
        message: '上传成功',
        type: 'success'
      });
      this.showPic = true;
      this.typeImg = formatTypeImg(
        this.fileName.substring(this.fileName.lastIndexOf("."), this.fileName.length)
      );
      // this.filePathList.push(
      //   formatTypeImg(
      //     this.fileName.substring(this.fileName.lastIndexOf("."), this.fileName.length)
      //   )
      // )
      setTimeout(() => {
        this.isToast = false;
        this.toastMsg = "";
      }, 1500);
    },
    handleError() {
      this.isToast = true;
      // this.toastMsg = "上传失败";
      this.$message.error('上传失败');
      setTimeout(() => {
        this.isToast = false;
        this.toastMsg = "";
      }, 1500);
    },
    deleteFile(t,o) {
      // this.filePathList = this.filePathList.splice(item =>  item.uid == t.uid );
      if(t.uid) {
        console.log('本地上传是图片')
        let arr = this.filePathList.map((item,idx) => {
          if(item.uid == t.uid) {
            return idx
          } else {
            return false
          }
        })
        this.filePathList.splice(arr.filter(Boolean)[0] ? arr.filter(Boolean)[0] : 0,1);
      } else {
        console.log('b节后返沪')
        
      let arr1 = this.fileuploadName.map((r,n) => {
        if(r == o) {
          return n
        } else {
          return false
        }
      })
      this.fileameView.splice(arr1.filter(Boolean)[0] ? arr1.filter(Boolean)[0] : 0,1);
      this.fileuploadName.splice(arr1.filter(Boolean)[0] ? arr1.filter(Boolean)[0] : 0,1);

      }
      // this.filePathList = arr;
      // this.filePathList = arr;
      // this.filePath = "";
      // this.fileName = "";
      // this.showPic = false;
      // this.typeImg = '';

    },
  },
}
